import React from "react";
import { useLocation } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import classNames from "classnames";
import { NavLinkProps } from "../NavLink.types";
import { NAV_LINK_CLASS_NAMES } from "../NavLink.constants";


const HashLinkCustom: React.FC<NavLinkProps> = ({ children, className, to, activeByDefault, onClick }) => {   
   const location = useLocation();
   const isHashEmpty = () => {      
      return !location.hash;
   }
   const linkClassNames = classNames(NAV_LINK_CLASS_NAMES.nav, {[NAV_LINK_CLASS_NAMES.navActive]: activeByDefault && isHashEmpty()}, className);
   return (<NavHashLink to={to} className={linkClassNames} activeClassName={NAV_LINK_CLASS_NAMES.navActive} onClick={onClick}>
      {children}
   </NavHashLink>);
}

export default HashLinkCustom;